module.exports = __webpack_public_path__ + "img/home-left.0012acec.svg";